<input
  [formControl]="control"
  class="w-full"
  pInputText
  placeholder="Wprowadź wartość" />
